// Pure client-side mirror of backend compute_stall_status (services/pdca_integration.py).
// No network, no storage — computed on render.

function addMonths(date, months) {
  const d = new Date(date.getTime());
  const targetMonth = d.getMonth() + months;
  const targetYear = d.getFullYear() + Math.floor(targetMonth / 12);
  const normalizedMonth = ((targetMonth % 12) + 12) % 12;
  const day = d.getDate();
  const result = new Date(d.getTime());
  result.setFullYear(targetYear, normalizedMonth, 1);
  const daysInMonth = new Date(targetYear, normalizedMonth + 1, 0).getDate();
  result.setDate(Math.min(day, daysInMonth));
  return result;
}

const DAY_MS = 86400000;

export function computeStallStatus(lastActivityDate, frequencyMonths, currentDate = null) {
  const now = currentDate ? new Date(currentDate) : new Date();
  const freq = parseInt(frequencyMonths, 10) || 12;

  if (!lastActivityDate) {
    return {
      effective_status: "never_tested",
      days_remaining: null,
      days_overdue: null,
      frequency_months: freq,
      deadline: null,
      escalation_level: 3,
    };
  }

  const last = new Date(lastActivityDate);
  const deadline = addMonths(last, freq);
  const daysTo = Math.round((deadline.getTime() - now.getTime()) / DAY_MS);

  if (now.getTime() < deadline.getTime() - 30 * DAY_MS) {
    return { effective_status: "current", days_remaining: daysTo, days_overdue: null,
      frequency_months: freq, deadline, escalation_level: 0 };
  }
  if (now.getTime() < deadline.getTime()) {
    return { effective_status: "approaching_due", days_remaining: daysTo, days_overdue: null,
      frequency_months: freq, deadline, escalation_level: 0 };
  }
  const daysOver = Math.round((now.getTime() - deadline.getTime()) / DAY_MS);
  let level = 1;
  if (now.getTime() >= deadline.getTime() + 60 * DAY_MS) level = 3;
  else if (now.getTime() >= deadline.getTime() + 30 * DAY_MS) level = 2;
  return { effective_status: "overdue", days_remaining: null, days_overdue: daysOver,
    frequency_months: freq, deadline, escalation_level: level };
}

// UI presentation for an effective_status value.
export const CURRENCY_BADGE = {
  current: { label: "Current", className: "bg-emerald-100 text-emerald-700 border border-emerald-200" },
  approaching_due: { label: "Approaching Due", className: "bg-amber-100 text-amber-700 border border-amber-200" },
  overdue: { label: "Overdue", className: "bg-red-100 text-red-700 border border-red-200" },
  never_tested: { label: "Never Tested", className: "bg-slate-100 text-slate-500 border border-slate-200" },
};

// Dot color for calendar indicators.
export const CURRENCY_DOT = {
  current: "bg-emerald-500",
  approaching_due: "bg-amber-500",
  overdue: "bg-red-500",
  never_tested: "bg-slate-400",
};
